import GuidedPractice from './GuidedPractice';
import GuidedPracticeIntroduction from './Containers/Introduction';
import { ExamResults, ExamRoom } from './Containers/ExamRoom';

export { GuidedPracticeIntroduction, ExamResults, ExamRoom };
export default GuidedPractice;
